import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/80 backdrop-blur-xl border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')} data-testid="header-logo">
            <div className="w-10 h-10 bg-red-700 flex items-center justify-center">
              <span className="text-white font-bold text-lg font-heading tracking-wider">UVD</span>
            </div>
            <div className="hidden sm:block">
              <h1 className="text-lg font-bold text-white tracking-wide font-heading">UVD MEDIA</h1>
              <p className="text-[10px] text-gray-500 uppercase tracking-[0.2em]">
                Thriller Trailers
                <span className="mx-2 text-gray-700">|</span>
                <a 
                  href="/admin/login"
                  className="text-gray-600 hover:text-gray-400 transition-colors duration-200"
                  data-testid="admin-link"
                >
                  Admin
                </a>
              </p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-testid="desktop-nav">
            {['promo-services', 'our-work', 'about', 'faq'].map((section) => (
              <button
                key={section}
                onClick={() => scrollToSection(section)}
                className="text-sm uppercase tracking-[0.15em] text-gray-400 hover:text-white transition-colors duration-200"
                data-testid={`nav-${section}`}
              >
                {section === 'promo-services' ? 'Services' : section === 'our-work' ? 'Our Work' : section.charAt(0).toUpperCase() + section.slice(1)}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-red-700 hover:bg-red-800 text-white text-sm font-bold uppercase tracking-[0.15em] px-6 py-3 transition-colors duration-200"
              data-testid="nav-cta"
            >
              Send Your Synopsis
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-xl py-6 space-y-1 border-t border-white/10" data-testid="mobile-menu">
            {['promo-services', 'our-work', 'about', 'faq'].map((section) => (
              <button
                key={section}
                onClick={() => scrollToSection(section)}
                className="block w-full text-left px-4 py-3 text-sm uppercase tracking-[0.15em] text-gray-400 hover:text-white hover:bg-white/5 transition-all duration-200"
                data-testid={`mobile-nav-${section}`}
              >
                {section === 'promo-services' ? 'Services' : section === 'our-work' ? 'Our Work' : section.charAt(0).toUpperCase() + section.slice(1)}
              </button>
            ))}
            <div className="px-4 pt-4">
              <button
                onClick={() => scrollToSection('contact')}
                className="w-full bg-red-700 hover:bg-red-800 text-white text-sm font-bold uppercase tracking-[0.15em] px-6 py-3 transition-colors duration-200"
                data-testid="mobile-nav-cta"
              >
                Send Your Synopsis
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
